<template>
  <div id="app">
    <v-app>
      <router-view></router-view>
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000000;
  font-family: "Helvetica Neue", Inter, ui-sans-serif, "Apple Color Emoji", Helvetica, Arial, sans-serif;
}
.primario{
  background-color: #112c3d !important;
}
.secundario{
  background-color: #78aed0 !important;
}
.terciario{
  background-color: #ffca00 !important;
}
.txtp{
  color: #112c3d !important;
}
.txts{
  color: #675236 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue